import type { RouterUseQueryOptions } from '@newfront-insurance/data-layer-client';

import { useAdminTRPC } from '../../../shared/providers/trpc';
import type { SharedRouter } from '../../../shared/trpc/router';

/**
 * All producers, without auth roles. Prefer this over `useProducers` for selectors, avatars and
 * name lookups — it skips the per-employee role lookup that `useProducers` pays for. If you need
 * `roles` or `departments`, use `useProducers`.
 */
export function useProducerSummaries(options?: RouterUseQueryOptions<SharedRouter, 'employees.getProducerSummaries'>) {
  const { useQuery } = useAdminTRPC();

  return useQuery(['employees.getProducerSummaries'], options);
}
